"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ability_HotStreak_OnAttackEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const HotStreak_1 = require("../../core/effects/core/HotStreak");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Ability_HotStreak_OnAttackEventHandlerScript = class Ability_HotStreak_OnAttackEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.Attack) {
            return;
        }
        handler.meta.consecutiveHits = handler.meta.consecutiveHits || 0;
        if (handler.meta.consecutiveHits > 20) {
            return;
        }
        container.cancelEffect(sequence, handler.meta.effectId);
        if (!event.args.hit) {
            handler.meta.consecutiveHits = 0;
            return;
        }
        handler.meta.consecutiveHits++;
        const { lastAnimatedAt } = handler.meta;
        handler.meta.lastAnimatedAt = container.getActor(handler.subject).turnCount;
        handler.meta.effectId = container.applyBuff({
            sequence,
            creatorId: handler.subject,
            targetId: handler.subject,
            effect: new HotStreak_1.HotStreakEffectArgs(handler.meta.consecutiveHits * 5, lastAnimatedAt === handler.meta.lastAnimatedAt),
            duration: Duration_1.Duration.Permanent,
        });
    }
};
Ability_HotStreak_OnAttackEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Ability_HotStreak_OnAttack")
], Ability_HotStreak_OnAttackEventHandlerScript);
exports.Ability_HotStreak_OnAttackEventHandlerScript = Ability_HotStreak_OnAttackEventHandlerScript;
